import { actions } from './social/actions'
import { getters } from './social/getters'
import { state } from './social/state'
import { mutations } from './social/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
